/* eslint-disable no-shadow */
import React from "react";

import { kebabCase } from "lodash";
import { useRouter } from "next/router";

import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import VaspsNetwork from "../components/VaspsNetwork";
import { NoResultsMessage } from "../components/VaspsNetwork/VaspsNetwork";
import {
  Container,
  HeroSection,
  HeroCenteredSection,
  HeroH1,
  HeroContent,
  NavContainer,
  Input,
  InputSection,
  SearchContent,
} from "./styles";

import { Padding } from "~/components/Elements";
import SEO from "~/components/SEO";
import questions from "~/components/SEO/schemas/questions.json";
import FAQ from "~/templates/network/components/FAQ";
import Products from "~/templates/network/components/Products";
import { VASP } from "~/types/vaspid";

interface NetworkSearchPageServerSideProps {
  isProductionEnv: boolean;
}

export default function NetworkSearchPage({ isProductionEnv }: NetworkSearchPageServerSideProps) {
  const router = useRouter();

  const onClickVasp = (vasp: VASP) => {
    if (vasp.subsidiaries && vasp.subsidiaries.length > 0) {
      const params = new URLSearchParams({ ...router.query, subsidiariesOf: vasp.did }).toString();
      router.push(`/network/search?${params}`, undefined, { shallow: true });
    } else {
      router.push(`/network/${vasp.did}/${kebabCase(vasp.name || undefined)}`);
    }
  };

  return (
    <>
      <SEO
        title={`Search for VASPs that are Travel Rule compliant | Notabene`}
        description={`Search for crypto companies & VASPs that are Travel Rule compliant. Find out more about them & the Crypto Travel Rule using Notabene’s free VASP network!`}
        enableCrawlerIndex={isProductionEnv}
      >
        <script
          key="schema-questions"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(questions),
          }}
        />
      </SEO>

      <Container id="vasp_search_top">
        <VaspsNetwork onClickVasp={onClickVasp} trackingActionCategory="public-directory">
          {({ term, setTerm, sortFilterContent, filtersContent, resultsContent }) => (
            <>
              <HeroSection>
                <HeroContent>
                  <NavContainer>
                    <Navbar inverted navBarForSearchPage />
                  </NavContainer>
                  <HeroCenteredSection>
                    <HeroH1>Search VASPs &amp; crypto companies</HeroH1>
                    <InputSection>
                      <Input
                        value={term}
                        onChange={(event) => setTerm(event.target.value)}
                        placeholder="Enter company name"
                      />
                    </InputSection>
                  </HeroCenteredSection>
                </HeroContent>
              </HeroSection>
              <SearchContent>
                <Padding sized="small">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "30px",
                      rowGap: "15px",
                      flexWrap: "wrap",
                      marginBottom: "15px",
                    }}
                  >
                    {sortFilterContent}
                    {filtersContent}
                  </div>
                </Padding>
                {resultsContent === null ? (
                  <p className="p-6 has-text-centered">
                    <NoResultsMessage />
                  </p>
                ) : (
                  resultsContent
                )}
              </SearchContent>
            </>
          )}
        </VaspsNetwork>
        <FAQ />
        <Products />
        <Footer />
      </Container>
    </>
  );
}
